export default __webpack_public_path__ + "static/media/img-26.bcaeef10.jpg";